function track(...args) {
  if ('ga' in window && window.ga.getAll) {
    const [tracker] = window.ga.getAll();

    if (tracker) {
      tracker.send(...args);
    }
  }
}

export { track };
